// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3v6WH","item":"PaymentsMobile_item__2kTy4","label":"PaymentsMobile_label__2QD-2","amount":"PaymentsMobile_amount__1Bhpm"};